// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Trash from '../_raw/ui/icon_trash.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Trash);
